import { PR_ANCHOR_IDS } from "./index";

export const REVIEW_GALLERY_MAX_VISIBLE = 6;
export const CUSTOMER_GALLERY_ATTR = "data-pr-gallery";

const OVERFLOW_ATTR = "data-pr-gallery-overflow";
const MORE_ATTR = "data-pr-gallery-more";
const BASE_LABEL_ATTR = "data-pr-gallery-label";
const EMPTY_ATTR = "data-pr-gallery-empty";

function setAttribute(el: Element, name: string, value: string): void {
	if (el.getAttribute(name) !== value) {
		el.setAttribute(name, value);
	}
}

function clearMore(tile: Element): void {
	if (!tile.hasAttribute(MORE_ATTR)) return;
	tile.removeAttribute(MORE_ATTR);
	const base = tile.getAttribute(BASE_LABEL_ATTR);
	if (base !== null) {
		tile.setAttribute("aria-label", base);
		tile.removeAttribute(BASE_LABEL_ATTR);
	}
}

function markMore(
	tile: Element,
	hiddenCount: number,
	formatMore: (count: number) => string
): void {
	setAttribute(tile, MORE_ATTR, `+${hiddenCount}`);
	const base =
		tile.getAttribute(BASE_LABEL_ATTR) ??
		tile.getAttribute("aria-label") ??
		tile.querySelector("img")?.getAttribute("alt") ??
		"";
	setAttribute(tile, BASE_LABEL_ATTR, base);
	const more = formatMore(hiddenCount);
	setAttribute(tile, "aria-label", base ? `${base}, ${more}` : more);
}

function capTiles(
	gallery: Element,
	tiles: Element[],
	formatMore: (count: number) => string
): void {
	gallery.toggleAttribute(EMPTY_ATTR, tiles.length === 0);

	const hiddenCount = Math.max(0, tiles.length - REVIEW_GALLERY_MAX_VISIBLE);
	tiles.forEach((tile, index) => {
		tile.toggleAttribute(
			OVERFLOW_ATTR,
			index >= REVIEW_GALLERY_MAX_VISIBLE
		);
		const isLastVisible = index === REVIEW_GALLERY_MAX_VISIBLE - 1;
		if (isLastVisible && hiddenCount > 0) {
			markMore(tile, hiddenCount, formatMore);
		} else {
			clearMore(tile);
		}
	});
}

export function decorateReviewImages(
	root: ParentNode,
	formatMore: (count: number) => string
): void {
	root.querySelectorAll(".pr-rd-images").forEach((gallery) => {
		capTiles(
			gallery,
			Array.from(
				gallery.querySelectorAll(":scope > .pr-rd-image-container")
			),
			formatMore
		);
	});
}

export function createCustomerGallery(title: string): HTMLElement {
	const wrapper = document.createElement("div");
	wrapper.setAttribute(CUSTOMER_GALLERY_ATTR, "");
	wrapper.setAttribute(EMPTY_ATTR, "");
	const heading = document.createElement("h3");
	heading.className = "pr-customer-gallery-title";
	heading.textContent = title;
	const anchor = document.createElement("div");
	anchor.id = PR_ANCHOR_IDS.imageDisplay;
	wrapper.append(heading, anchor);
	return wrapper;
}

export function placeCustomerGallery(
	root: ParentNode,
	wrapper: HTMLElement,
	formatMore: (count: number) => string
): void {
	capTiles(
		wrapper,
		Array.from(wrapper.querySelectorAll(".pr-irlsnippet-image-container")),
		formatMore
	);

	const container = root.querySelector(".pr-review-display")?.parentElement;
	if (!container) return;
	const anchor = container.querySelector(
		":scope > .p-w-r_future, :scope > .pr-review-display"
	);
	if (!anchor || wrapper.nextElementSibling === anchor) return;
	container.insertBefore(wrapper, anchor);
}
